import image from '@/assets/images/manufacturers/getec.png';
import { option } from '@/util/container';
import { MANUFACTURERS } from '..';

export default option(MANUFACTURERS, async () => ({
  name: 'GETEC',
  label: 'GETEC net GmbH',
  image,
}));
